type Definition = {
  term: string;
  description: string;
};

export function MetricDefinitions({
  summary,
  definitions,
}: {
  /** Optional intro line describing the chart before the per-series breakdown. */
  summary?: string;
  definitions: Definition[];
}) {
  return (
    <div className="flex max-w-xs flex-col gap-2">
      {summary && <p>{summary}</p>}
      <ul className="flex flex-col gap-2">
        {definitions.map(({ term, description }) => (
          <li key={term}>
            <span className="font-semibold">{term}:</span> {description}
          </li>
        ))}
      </ul>
    </div>
  );
}
